import { HttpInterceptorFn } from '@angular/common/http';

export const getXHostValue = (): string => {
  if (
    typeof window !== 'undefined' &&
    window.location?.hostname === 'client.photobooth.awh.co.id'
  ) {
    return 'client.photobooth.awh.co.id';
  }
  return 'dev.client.photobooth.awh.co.id';
};

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('auth_token');
  const currentHost = getXHostValue();

  const setHeaders: Record<string, string> = {
    'X-HOST': currentHost,
    Accept: 'application/json',
  };

  if (token) {
    setHeaders['Authorization'] = `Bearer ${token}`;
  }

  const cloned = req.clone({ setHeaders });
  return next(cloned);
};
